/** Budget and runaway rows for Overview's "Needs you", in the shape its rows already use. */
import { Flame, OctagonX, Wallet } from '@orgus/ui/icons';
import { useMemo } from 'react';
import type { ComponentType } from 'react';
import type { NeedItem } from '../overview/needsYou.ts';
import { budgetNeeds } from './model.ts';
import { useCosts } from './useCosts.ts';

export type BudgetNeedKind = 'budget' | 'budgetOver' | 'runaway';

export interface BudgetNeedItem extends Omit<NeedItem, 'kind'> {
  kind: BudgetNeedKind;
}

export const BUDGET_NEED_KIND: Record<BudgetNeedKind, { icon: ComponentType<{ className?: string }>; cls: string; label: string }> = {
  budgetOver: { icon: OctagonX, cls: 'text-failed bg-failed-soft', label: 'Over budget' },
  budget: { icon: Wallet, cls: 'text-waiting bg-waiting-soft', label: 'Near budget' },
  runaway: { icon: Flame, cls: 'text-waiting bg-waiting-soft', label: 'Runaway session' },
};

export function useBudgetNeedItems(): BudgetNeedItem[] {
  const costs = useCosts();
  return useMemo(
    () =>
      budgetNeeds(costs).map((n) => ({
        key: n.key,
        kind: n.state === 'hard' ? 'budgetOver' : n.state === 'soft' ? 'budget' : 'runaway',
        title: n.title,
        detail: n.detail,
        where: n.state === 'runaway' ? 'Spend' : 'Budgets',
        at: n.at,
        to: n.to,
        verb: n.state === 'runaway' ? 'Open' : 'Review',
      })),
    [costs],
  );
}
